// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"0981ce8b","513":"22a37b62","703":"0a8bbb4b","787":"d5c95246"}[chunkId] + ".chunk.js";
};